import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const PdqPaymentSchema = z.object({
  company: z.string().min(3),
  order: z.string(),
}); 

export type PdqPaymentSchemaType = z.infer<typeof PdqPaymentSchema>;

export async function payWithPdqService(formData: PdqPaymentSchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/payments/pdq`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}

